// extracted by mini-css-extract-plugin
export var chevron = "_2i-2";
export var chevronCollapsed = "_2i-3";
export var collapsibleHeader = "_2i-1";
export var container = "_2i-0";